import { fixedNumber } from './common';
import { LINE_DIR } from '../enums/index';

// 获取单根直角线的长度
export function getSingleLineSize(startX, startY, endX, endY) {
  // // 计算两点之间的直线距离
  // return Math.round(Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)));

  if (endX === startX || endY === startY) {
    return Math.abs(endX - startX) + Math.abs(endY - startY) || 0
  } else {
    return getSingleLineSizeWithAngle(startX, startY, endX, endY);
  }
}

// 获取两点之间距离 包括斜线
export function getSingleLineSizeWithAngle(startX, startY, endX, endY) {
  const xS = Math.abs(endX - startX);
  const yS = Math.abs(endY - startY);

  return Math.sqrt(Math.pow(xS, 2) + Math.pow(yS, 2)) || 0;
}

// 线方向  ROWLR 横向 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
export function getLineDirection(startX, startY, endX, endY) {
  // x一致 纵向
  if (startX === endX) {
    return endY > startY ? LINE_DIR.COLTB : LINE_DIR.COLBT
  }

  // y一致 横向
  if (startY === endY) {
    return endX > startX ? LINE_DIR.ROWLR : LINE_DIR.ROWRL;
  }

  const plusX = Math.abs(startX - endX);
  const plusY = Math.abs(startY - endY);

  // 纵向角度
  if (plusY > plusX) {
    return endY > startY ? LINE_DIR.ANGLE_COL_TB : LINE_DIR.ANGLE_COL_BT;
  }

  // 横向角度
  if (plusX >= plusY) {
    return endX > startX ? LINE_DIR.ANGLE_ROW_LR : LINE_DIR.ANGLE_ROW_RL;
  }
}

// 是纵向 1 还是 横向 0
export function getRelationWithPointer(curX, otherX) {
  return curX === otherX ? LINE_DIR.COL : LINE_DIR.ROW;
}

/**
 * 获取线数据
 * @param {*} node 
 * @param {*} startX 
 * @param {*} startY 
 * @param {*} endX 
 * @param {*} endY 
 * @returns 
 */
export function getLineRenderData(node, startX, startY, endX, endY) {
  const size = getSingleLineSize(startX, startY, endX, endY);
  const lastLine = (node.pre || {}).pre;
  const startSize = lastLine ? lastLine.renderData.endSize : 0;

  return {
    ...node.renderData,
    startX: fixedNumber(startX),
    startY: fixedNumber(startY),
    endX: fixedNumber(endX),
    endY: fixedNumber(endY),
    size: fixedNumber(size), // 当前线长度
    startSize: fixedNumber(startSize),
    endSize: fixedNumber(startSize + size), // 当前灯带总长
    direction: getLineDirection(startX, startY, endX, endY), // 线方向 ROWLR 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
  }
}

/**
 * 获取网关上的坐标数据
 * @param {*} offsetX 
 * @param {*} offsetY 
 * @returns 
 */
export function transWangePos(offsetX, offsetY, singPx) {
  const xWangge1 = Math.floor(offsetX / singPx) * singPx;
  const yWangge1 = Math.floor(offsetY / singPx) * singPx;
  const xWangge2 = Math.ceil(offsetX / singPx) * singPx;
  const yWangge2 = Math.ceil(offsetY / singPx) * singPx;

  let xWangge, yWangge;

  if (Math.abs(offsetX - xWangge1) < Math.abs(offsetX - xWangge2)) {
    xWangge = xWangge1
  } else {
    xWangge = xWangge2
  }

  if (Math.abs(offsetY - yWangge1) < Math.abs(offsetY - yWangge2)) {
    yWangge = yWangge1
  } else {
    yWangge = yWangge2
  }

  return {
    xWangge,
    yWangge
  };
}

  